import React from 'react';

import { PropertyTextInput } from '@paragon/client-tools';

import { getDistanceFormatterSelector } from '../../../../store/selectors/getDistanceFormatterSelector';
import { useAppSelector } from '../../../hooks';

interface PositionFieldProps {
  readonly position: { x: number; y: number } | null;
  readonly labelAdjective: string;
  readonly placeholderText: string;
}

export function PositionField(props: PositionFieldProps) {
  const { position, placeholderText, labelAdjective } = props;
  const formatDistance = useAppSelector(getDistanceFormatterSelector);

  if (position === null) {
    return <PropertyTextInput sx={{ m: 1 }} disabled property={`${labelAdjective} Position`} value={placeholderText} />;
  }

  return (
    <PropertyTextInput
      sx={{ m: 1 }}
      disabled
      property={`${labelAdjective} Position`}
      value={`${formatDistance(position.x)} x ${formatDistance(position.y)}`}
    />
  );
}
